import { render, staticRenderFns } from "./Certification_System.vue?vue&type=template&id=208d8e93&scoped=true&"
import script from "./Certification_System.vue?vue&type=script&lang=js&"
export * from "./Certification_System.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "208d8e93",
  null
  
)

export default component.exports